import styled from 'styled-components';

const Track = styled.div<{ $thin?: boolean }>`
    width: 100%;
    height: ${({ $thin }) => ($thin ? '3px' : '6px')};
    background: #f0f0f0;
    border-radius: 3px;
    overflow: hidden;
`;

const Fill = styled.div<{ $percent: number }>`
    width: ${({ $percent }) => `${Math.max($percent, 0.5)}%`};
    height: 100%;
    background: ${({ $percent }) => ($percent > 0 ? '#22c55e' : '#e0e0e0')};
    border-radius: 3px;
    transition: width 0.3s ease;
`;

interface ProgressBarProps {
    /** Value between 0 and 1 */
    value: number;
    thin?: boolean;
}

export function ProgressBar({ value, thin }: ProgressBarProps) {
    const percent = Math.round(value * 100);
    return (
        <Track $thin={thin}>
            <Fill $percent={percent} />
        </Track>
    );
}
